import { useState } from "react";
import AdminLegalTerms from "./AdminLegalTerms";
import AdminLegalPrivacy from "./AdminLegalPrivacy";
import AdminLegalContract from "./AdminLegalContract";

const SETTINGS_CARDS = [
    { id: "terms", icon: "fa-file-contract", title: "Termos de Uso", desc: "Edite e publique os termos de uso da plataforma" },
    { id: "privacy", icon: "fa-shield-halved", title: "Política de Privacidade", desc: "Edite e publique a política de privacidade" },
    { id: "contract", icon: "fa-handshake", title: "Contrato de Afiliados", desc: "Edite o contrato do programa de afiliados (exige reaceite)" },
];

/**
 * AdminSettings — hub "Configurações" do Painel Mestre. Reúne os documentos
 * legais da plataforma (antes soltos direto na sidebar principal).
 */
const AdminSettings = () => {
    const [view, setView] = useState("hub");

    if (view === "terms") return <AdminLegalTerms onBack={() => setView("hub")} />;
    if (view === "privacy") return <AdminLegalPrivacy onBack={() => setView("hub")} />;
    if (view === "contract") return <AdminLegalContract onBack={() => setView("hub")} />;

    return (
        <div className="space-y-6" data-testid="admin-settings-hub">
            <div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-indigo-400">Plataforma</div>
                <h1 className="salon-heading text-3xl text-white mt-1">Configurações</h1>
                <p className="text-sm text-slate-400 mt-1">Documentos legais e configurações gerais da plataforma.</p>
            </div>
            <div className="grid sm:grid-cols-2 gap-4 max-w-2xl">
                {SETTINGS_CARDS.map((c) => (
                    <button
                        key={c.id}
                        data-testid={`admin-settings-card-${c.id}`}
                        onClick={() => setView(c.id)}
                        className="text-left rounded-2xl border border-white/5 bg-slate-900/40 backdrop-blur-xl p-5 hover:border-indigo-500/40 transition-all group"
                    >
                        <div className="flex items-center justify-between mb-4">
                            <div className="h-11 w-11 rounded-xl bg-indigo-500/10 flex items-center justify-center">
                                <i className={`fa-solid ${c.icon} text-lg text-indigo-300`}></i>
                            </div>
                            <i className="fa-solid fa-arrow-right text-slate-600 group-hover:text-indigo-300 group-hover:translate-x-1 transition-all"></i>
                        </div>
                        <div className="text-white text-base font-medium mb-1">{c.title}</div>
                        <div className="text-xs text-slate-500">{c.desc}</div>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default AdminSettings;
